"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Encoder = void 0;
const CborEncoder_1 = require("@jsonjoy.com/json-pack/lib/cbor/CborEncoder");
const CrdtWriter_1 = require("../../../../json-crdt-patch/util/binary/CrdtWriter");
const BatchColumnEncoder_1 = require("../BatchColumnEncoder");
class Encoder extends CborEncoder_1.CborEncoder {
    constructor(writer = new CrdtWriter_1.CrdtWriter()) {
        super(writer);
        this.writer = writer;
    }
    encodeBatch(batch) {
        this.writer.reset();
        this.writeBatch(batch);
        return this.writer.flush();
    }
    writeBatch(batch) {
        const columns = new BatchColumnEncoder_1.BatchColumnEncoder();
        columns.build(batch);
        // console.log(columns);
        const writer = this.writer;
        writer.vu57(columns.minSeq);
        writer.vu57(columns.maxSeq);
        this.writeUintCol(columns.sidTable);
        this.writeUintCol(columns.uint);
        this.writeUintCol(columns.s_old);
        this.writeUintCol(columns.s_new);
        this.writeUintCol(columns.t_obj);
        this.writeUintCol(columns.t_id);
        this.writeUintCol(columns.t_val);
        this.writeCborCol(columns.data);
        this.writeCborCol(columns.meta);
    }
    writeUintCol(uint) {
        const length = uint.length;
        const writer = this.writer;
        writer.ensureCapacity(8 + 8 * length);
        writer.vu57(length);
        for (let i = 0; i < length; i++)
            writer.vu57(uint[i]);
    }
    writeCborCol(data) {
        const length = data.length;
        const writer = this.writer;
        writer.vu57(length);
        for (let i = 0; i < length; i++)
            this.writeAny(data[i]);
    }
}
exports.Encoder = Encoder;
